'use strict';

var _                   = require('underscore');
var $                   = require('jquery');
var Core                = require('../core/core.js');
var Inspector           = require('../inspector/inspector.js');
var InspectorModalBox   = require('../inspector/inspector__modalbox.js');
var Theme               = require('../theme/theme.js');
var Tray                = require('../tray/tray.js');
var SnapTool            = require('../snaptool/snaptool.js');
var Library             = require('../library/library.js');

/**
 * Creates a Editor Holder
 *
 * @class
 */

class EditorHolder extends Core {

    _defaults() {
        return {
            target: '.js-editor__holder',
            fields: {}
        };
    }

    constructor(options) {
        super(options);

        this.template = `
            <div class='editor__holder'>
                <div class='editor__holder__yield js-editor__holder__yield'></div>
                <div class='js-editor__holder__tray'></div>
                <div class='js-editor__holder__snaptool'></div>
            </div>
        `;

        super.render();
    }

    /**
     * Adds an inspector to the editorHolder
     * @param {String} name - the name of the inspector, will be shown in the top part of the inspector
     * @param {String} description
     */
    addInspector(name, description){
        // var inspector_div =  $("<div class='js-editor__holder__inspector'></div>");
        // this.$el.append(inspector_div);
        return new Inspector({
            target: this.$el,
            fields: {
                'name': name,
                'description': description
            }
        });
    }

    /**
     * Adds a modal box, for the inspector to use, to the editorHolder
     */
    addInspectorModalBox() {
      return new InspectorModalBox({
        target: $('.js-editor__holder__inspector', this.$el)
      });
    }

    /**
     * Adds a overlay tray to the tab
     */
    addTray(initial_show){
        return new Tray({
            target: $('.js-editor__holder__tray', this.$el),
            fields: {
                'initial_show': initial_show
            }
        });
    }


    /**
     * Adds a overlay snap tool to the grid
     */
    addSnapTool(){
        return new SnapTool({
            target: $('.js-editor__holder__snaptool', this.$el)
        });
    }


    /**
     * Adds a overlay import modal dialog
     */
    addImportDialog(options){
        // ImportModal is not defined anywhere in our code!
        return new ImportModal(options);
    }

    /**
     * Adds a overlay import modal dialog
     */
    addExportDialog(fields){
        // ExportModal is not defined anywhere in our code!
        return new ExportModal({
            target: $('body'),
            fields: fields
        });
    }

    /**
     * Adds a overlay share modal dialog
     */
    addShareDialog(options){
        // ShareModal is not defined anywhere in our code!
        return new ShareModal(options);
    }

    /**
     * Adds a library
     */
    addLibrary(info){
        return new Library({
            target: $('.js-editor__holder__yield', this.$el),
            fields: {
                'name': info.name,
                'summary': info.summary,
                'description': info.description,
                'user': info.user,
                'date': info.date,
                'asset_count': info.asset_count,
                'configuration': info.configuration
            }
        });
    }


    /**
     * get the jquery element that holds the editor holder
     * @returns {Object} jquery_yield - returns a jquery selection
     */
    getEditorHolderEl(){
        return this.$el;
    }

    /**
     * get the yield from this Editor Holder where the editor can be placed
     * @returns {Object} jquery_yield - returns a jquery selection of the yield div
     */
    getCanvasEl(){
        return $('.js-editor__holder__yield', this.$el);
    }

    /**
     * Set the tab theme
     */
    setTheme(theme){
        Theme(theme, this.$el);
    }

}
module.exports = EditorHolder;
